import { generateIconsForSizes } from "@/src/easy-icons/utils/iconComponentManager";
import { ICON_METADATA } from "@/src/easy-icons/constants/iconsMetadata";

/**
 * This object maps icon names to their corresponding Vue component names.
 * The values are the names of the Vue components that represent each icon.
 */
export const ICON_COMPONENTS_MAP = {
  add: "e-add",
  assistant: "manga-63",
  attach: "attach",
  attachment: "attach",
  circleAdd: "c-add",
  arrowDown: "arrow-down",
  arrowUp: "arrow-up",
  chatBot: "chat-bot",
  boxArrowBottomRight: "box-arrow-bottom-right",
  boxArrowTopRight: "box-arrow-top-right",
  cancel: "c-remove",
  check: "check",
  change: "change-direction",
  checkboxOff: "checkbox-btn",
  checkboxOn: "checkbox-btn-checked",
  clear: "c-remove",
  complete: "check",
  copy: "copy-2",
  delete: "bin",
  done: "check-double",
  documentation: "book-39",
  edit: "pen",
  briefcase: "briefcase-24",
  export: "export",
  favorite: "favorite",
  feature: "loudspeaker",
  file: "file",
  first: "pointing-left",
  goal: "goal-65",
  last: "pointing-right",
  link: "link",
  loading: "reload",
  menu: "menu-8",
  more: "dots",
  radioOff: "radio-btn",
  radioOn: "radio-btn-checked",
  remove: "e-delete",
  search: "search",
  settings: "setup-preferences",
  sort: "sort-tool",
  sortAsc: "arrow-up",
  sortDesc: "arrow-down",
  squareAdd: "s-add",
  success: "c-check",
  summary: "book-open-2",
  unlink: "unlink",
  user: "user",
  close: "e-remove",
  eye: "eye",
  star: "star",
  chat: "a-chat",
  cyborg: "cyborg",
  digitalKey: "digital-key",
  dropdown: "arrow-sm-down",
  info: "c-info",
  minus: "i-delete",
  playMedia: "play-media",
  playlist: "video-playlist",
  plus: "i-add",
  poop: "poop",
  powerButton: "button-power",
  prev: "arrow-sm-left",
  refresh: "refresh-02",
  reload: "reload",
  repeatCycle: "repeat-cycle",
  send: "send",
  subgroup: "arrow-sm-down",
  time: "clock",
  users: "users",
  usersTalk: "users-meeting",
  warning: "warning-sign",
  write: "pencil",
  addTask: "task-add",
  calendar: "calendar",
  collapse: "caret-sm-up",
  delimiter: "shape-oval",
  email: "email",
  error: "o-warning",
  expand: "arrow-sm-down",
  "expand-less": "caret-sm-up",
  "expand-more": "arrow-sm-down",
  importAlt: "box-arrow-bottom-right",
  messages: "comments",
  next: "arrow-sm-right",
  question: "c-question",
  "quite-happy": "quite-happy",
  ratingEmpty: "star",
  unfold: "enlarge",
  upload: "data-upload",
  wink: "wink-11",
  palette: "palette",
  split: "split-branch",
  pin: "pin",
  moveToBoard: "move-to-board",
};

const {
  ICON_TO_SVGS_OUTLINED_12,
  ICON_TO_SVGS_FILLED_12,
  ICON_TO_SVGS_OUTLINED_16,
  ICON_TO_SVGS_FILLED_16,
  ICON_TO_SVGS_OUTLINED_24,
  ICON_TO_SVGS_FILLED_24,
  ICON_TO_SVGS_OUTLINED_32,
  ICON_TO_SVGS_FILLED_32,
} = generateIconsForSizes(ICON_METADATA, ICON_COMPONENTS_MAP);

export {
  ICON_TO_SVGS_OUTLINED_12,
  ICON_TO_SVGS_FILLED_12,
  ICON_TO_SVGS_OUTLINED_16,
  ICON_TO_SVGS_FILLED_16,
  ICON_TO_SVGS_OUTLINED_24,
  ICON_TO_SVGS_FILLED_24,
  ICON_TO_SVGS_OUTLINED_32,
  ICON_TO_SVGS_FILLED_32,
};
